import { UnderConstructionComponent } from '@components/shared/under-construction/under-construction.component';
import { Component } from '@angular/core';

@Component({
  selector: 'app-floor',
  imports: [UnderConstructionComponent],
  templateUrl: './floor.component.html'
})
export class FloorComponent {}
